// src/pages/Homepage.jsx
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiClock } from "react-icons/fi";
import { API_BASE } from "../config";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import TopInfoBar from "../components/TopInfoBar";
import ErrorMessage from "../components/ErrorMessage";
import SuccessMessage from "../components/SuccessMessage";
import { sanitizeFormData, sanitizeAndValidateEmail } from "../utils/inputValidation";
import { getUserFriendlyError } from "../utils/errorMessages";
import { logError } from "../utils/logger";

export default function HomePage() {
  const blue = "#3366CC";
  const navy = "#1F376C";
  const text = "#0F172A";
  const isLoggedIn =
    typeof window !== "undefined" && sessionStorage.getItem("isLoggedIn") === "true";

  const container = {
    width: "100%",
    minWidth: "100vw",
    background: "#fff",
    overflow: "visible",
    fontFamily:
      "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial",
  };

// const responsiveCSS = `
  // /* พื้นฐานคอนเทนเนอร์ */
  // .page-container { width: 100%; overflow-x: hidden; }
// 
  // @media (max-width: 1200px) { 
    // .page-container { padding: 0; } 
  // }
// 
  // @media (max-width: 992px) {
    // .sticky-nav { padding: 0 20px !important; }
    // .hero-title { font-size: clamp(28px, 5vw, 42px) !important; }
    // .what-is { padding: 40px 32px !important; }
  // }
// 
  // @media (max-width: 768px) {
    // .top-info-bar { display: none !important; } /* ซ่อนแถบบนสุดในมือถือเพื่อประหยัดพื้นที่ */
    // .sticky-nav { height: 60px !important; padding: 0 16px !important; }
    // .desktop-nav { display: none !important; }
    // .hamburger-btn { display: inline-flex !important; }
    // 
    // .hero { height: auto !important; padding: 60px 20px !important; }
    // .hero-title { font-size: 32px !important; text-align: center; }
    // .cta-buttons { flex-direction: column !important; width: 100%; }
    // .cta-buttons > button { width: 100% !important; }
// 
    // .what-is { flex-direction: column !important; padding: 40px 20px !important; gap: 30px !important; }
    // .what-is-image { min-height: 250px !important; width: 100% !important; }
    // 
    // /* แก้ไขส่วน Grid 2 คอลัมน์ให้เหลือ 1 */
    // .grid-2 { 
      // grid-template-columns: 1fr !important; 
      // gap: 20px !important; 
    // }
// 
    // .free-trial-content { padding-right: 0 !important; }
    // footer { padding: 40px 20px !important; }
  // }
// 
  // @media (max-width: 480px) {
    // .hero-title { font-size: 28px !important; }
    // .section-title { font-size: 24px !important; }
  // }
// 
  // [id] { scroll-margin-top: 70px; }
// `;

const responsiveCSS = `
  .page-container { 
    width: 100% !important; 
    min-width: 100vw !important;
    overflow-x: hidden !important; 
    background: #fff;
  }

  /* Full-width sections */
  .top-info-bar,
  .sticky-nav-wrapper,
  .hero,
  section[style*="background: #3366CC"],
  section[style*="background: rgb(51, 102, 204)"],
  section[style*="background: linear-gradient(180deg"],
  section[id="free-trial"],
  footer {
    width: 100vw !important;
    position: relative !important;
    left: 50% !important;
    right: 50% !important;
    margin-left: -50vw !important;
    margin-right: -50vw !important;
    max-width: none !important;
    box-sizing: border-box !important;
  }

  /* Inner content containers */
  .content-wrapper {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 24px;
  }

  @media (max-width: 768px) {
    .top-info-bar { display: none !important; }

    .desktop-nav { 
      display: none !important; 
    }

    .hamburger-btn { 
      display: inline-flex !important; 
    }

    .sticky-nav {
      height: 60px !important;
      padding: 0 16px !important;
    }
    
    .grid-2 { 
      grid-template-columns: 1fr !important; 
      gap: 24px !important; 
    }

    .account-menu-panel {
      right: 10px !important;
      top: 50px !important;
      width: calc(100vw - 20px) !important;
      max-width: 300px !important;
    }

    .hero { 
      padding: 60px 20px !important; 
      min-height: auto !important;
    }

    .hero-title { 
      font-size: 32px !important; 
      text-align: center !important; 
      width: 100%;
    }

    .cta-buttons { 
      flex-direction: column !important; 
      width: 100% !important; 
      gap: 12px !important;
    }

    .cta-buttons > button { 
      width: 100% !important; 
      margin: 0 !important;
    }

    .what-is, #why-smartclick, #cta-card, #free-trial + section {
      padding: 40px 20px !important;
    }

    .what-is {
      flex-direction: column !important;
      gap: 30px !important;
    }

    .what-is .content-wrapper {
      flex-direction: column !important;
      gap: 30px !important;
    }

    .what-is > .content-wrapper > div:first-child {
      max-width: 100% !important;
      text-align: center !important;
    }

    .what-is ul {
      text-align: left !important;
      display: inline-block;
      width: 100%;
    }

    .what-is-image {
      min-height: 250px !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    .what-is .content-wrapper > div:first-child {
      order: 1;
    }

    .what-is .what-is-image {
      order: 2;
    }
  }

  @media (max-width: 992px) and (min-width: 769px) {
    .what-is .content-wrapper {
      flex-direction: column !important;
      gap: 40px !important;
    }

    .what-is > .content-wrapper > div:first-child {
      max-width: 100% !important;
      text-align: center !important;
    }

    .what-is ul {
      text-align: left !important;
      display: inline-block;
    }

    .what-is-image {
      width: 100% !important;
      max-width: 100% !important;
    }
  }

  [id] { scroll-margin-top: 70px; }
`;

  return (
    <>
      <style>{responsiveCSS}</style>
      <div style={container} className="page-container">
        <div className="top-info-bar">
          <TopInfoBar blue={blue} />
        </div>
        <div className="sticky-nav-wrapper" style={{ position: "sticky", top: 0, zIndex: 1000, background: "#fff", width: "100%" }}>
          <Navbar text={text} isLoggedIn={isLoggedIn} />
        </div>

        <Hero navy={navy} />
        <Pitch blue={blue} />
        <WhatIs />
        <WhySmartClick />
        <CTACard />
        <FreeTrialSection />
        <Footer />
      </div>
    </>
  );
}

// ใช้ shared Navbar component แทน - ลบ function เดิมออกแล้ว


/* ========= Hero (ปรับปรุงให้ชัดเจนขึ้น) ========= */
function Hero({ navy }) {
  const navigate = useNavigate();
  
  // --- สไตล์ปุ่มเดิมของคุณ (เก็บไว้แต่ปรับสีตัวอักษร) ---
  const btn = {
    padding: "14px 32px",
    borderRadius: 14,
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transform: "translateY(0)",
    userSelect: "none",
  };

  const primaryShadow = "0 4px 10px rgba(34,211,238,0.25), 0 8px 20px rgba(37,99,235,0.35)";
  const secondaryShadow = "0 4px 12px rgba(255,255,255,0.12), inset 0 0 12px rgba(255,255,255,0.1)";

  const primaryBtn = {
    ...btn,
    background: "linear-gradient(135deg,#22d3ee 0%,#0ea5e9 50%,#2563eb 100%)",
    color: "#fff",
    border: "1px solid rgba(14,165,233,0.7)",
    boxShadow: primaryShadow,
    transition: "transform 0.2s ease, box-shadow 0.25s ease",
  };

  const secondaryBtn = {
    ...btn,
    background: "rgba(255,255,255,0.15)", // เพิ่มความเข้มขึ้นนิดหน่อย
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.6)",
    boxShadow: secondaryShadow,
    backdropFilter: "blur(12px)", // เพิ่ม Blur ให้พื้นหลังปุ่ม
    transition: "transform 0.2s ease, box-shadow 0.25s ease",
  };

  // --- สไตล์ส่วน Datasheet (ปรับให้ชัดขึ้น) ---
  const linkBtn = {
    marginTop: 12,
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    color: "#38bdf8", // เปลี่ยนจากสีจางเป็นสีฟ้าสว่างเพื่อให้ตัดกับพื้นหลัง
    fontWeight: 700,
    fontSize: 15,
    background: "rgba(15,23,42,0.4)", // ใส่พื้นหลังดำจางๆ ให้ตัวหนังสือ
    padding: "8px 16px",
    borderRadius: 8,
    border: "none",
    cursor: "pointer",
    textDecoration: "none",
    transition: "all 0.2s ease",
  };

  const onBtnEnter = (e) => {
    e.currentTarget.style.transform = "translateY(-3px) scale(1.02)";
  };
  const onBtnLeave = (e, shadow) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = shadow;
  };

  const scrollToCTACard = () => {
    const section = document.getElementById("cta-card");
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  const handleCheckLicense = () => {
    const loggedIn = sessionStorage.getItem("isLoggedIn") === "true";
    navigate(loggedIn ? "/check" : "/login");
  };

  return (
    <section
      className="hero"
      style={{
        position: "relative",
        minHeight: "550px", // เพิ่มความสูงให้ดูโปร่งขึ้น
        backgroundImage: "url('https://ca-lab.isca.org.sg/wp-content/uploads/2024/09/shutterstock_1888805701.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        overflow: "hidden"
      }}
    >
      {/* 1. Overlay: แผ่นกรองสีดำเพื่อให้ตัวหนังสืออ่านง่ายขึ้นมาก */}
      <div 
        style={{ 
          position: "absolute", 
          inset: 0, 
          background: "linear-gradient(to right, rgba(15,23,42,0.85) 0%, rgba(15,23,42,0.4) 100%)",
          zIndex: 1 
        }} 
      />

      <div className="content-wrapper"
        style={{
          position: "relative",
          zIndex: 2, // ให้อยู่เหนือ Overlay
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 32,
        }}
      >
        <h1
          className="hero-title"
          style={{
            color: "#fff",
            fontSize: "clamp(32px, 6vw, 56px)", // ปรับขนาดอัตโนมัติตามจอ
            lineHeight: 1.2,
            fontWeight: 800,
            maxWidth: 800,
            margin: 0,
            textShadow: "0 4px 20px rgba(0,0,0,0.4)", // เพิ่มเงาให้ตัวอักษร
          }}
        >
          Enhance your <span style={{ color: "#38bdf8" }}>License Security</span>
          <br />
          with Smart Audit.
        </h1>

        <p style={{ color: "#e2e8f0", fontSize: "clamp(16px, 2vw, 18px)", maxWidth: 600, lineHeight: 1.6 }}>
          Centralized control hub for software licensing, identity, and compliance. 
          Monitor every client and device in real time.
        </p>

        <div className="cta-buttons" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          <button
            style={primaryBtn}
            onClick={scrollToCTACard}
            onMouseEnter={onBtnEnter}
            onMouseLeave={(e) => onBtnLeave(e, primaryShadow)}
          >
            Request Quote
          </button>
          <button
            style={secondaryBtn}
            onClick={handleCheckLicense}
            onMouseEnter={onBtnEnter}
            onMouseLeave={(e) => onBtnLeave(e, secondaryShadow)}
          >
            Check Your License
          </button>
        </div>

        <button
          style={linkBtn}
          onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(15,23,42,0.7)")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(15,23,42,0.4)")}
          onClick={() => window.open("/datasheet", "_blank", "noopener,noreferrer")}
        >
          <FiClock /> Download Data Sheet (PDF)
        </button>
      </div>
    </section>
  );
}

/* ========= Pitch ========= */
function Pitch({ blue }) {
  return (
    <section
      style={{
        background: blue,
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 24px",
        textAlign: "center",
      }}
    >
      <div className="content-wrapper" style={{ maxWidth: 1200 }}>
        <h2 style={{ fontSize: 26, fontWeight: 700, marginBottom: 18 }}>
          A license-security platform on demand
        </h2>
        <p style={{ maxWidth: 860, margin: "0 auto", lineHeight: 1.7, fontSize: 16 }}>
          Smart Audit empowers your organization with real-time license
          validation, secure activation, and audit-ready tracking — all in one
          platform. It eliminates unauthorized usage, strengthens access control,
          and supports fast, scalable deployment to match your evolving business
          needs.
        </p>
      </div>
    </section>
  );
}

/* ========= What is Smart Audit ========= */
function WhatIs() {
  return (
    <section
      id="what-is"
      className="what-is"
      style={{
        background: "#F5F7FA",
        padding: "80px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 40,
      }}
    >
      <div className="content-wrapper" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 40, width: "100%", maxWidth: 1440, margin: "0 auto" }}>
      {/* Left Content */}
      <div style={{ flex: 1, maxWidth: 560, minWidth: 0 }}>
        {/* Eyebrow / Tag */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "4px 10px",
            borderRadius: 999,
            background: "rgba(37, 99, 235, 0.08)",
            color: "#1D4ED8",
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: 0.6,
            textTransform: "uppercase",
            marginBottom: 12,
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: "999px",
            }}
          />
          License Control & Audit Automation
        </div>

        <h2
          style={{
            fontSize: 28,
            fontWeight: 800,
            marginBottom: 12,
            color: "#0F172A",
          }}
        >
          What is Smart Audit?
        </h2>

        <p
          style={{
            fontSize: 16,
            color: "#4B5563",
            lineHeight: 1.7,
            marginBottom: 20,
          }}
        >
          Smart Audit is your central control hub for{" "}
          <strong>software licensing, identity, and compliance</strong>.  
          It lets you issue, verify, and monitor licenses in real time –
          with full visibility over every client and every device.
        </p>

        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: 20,
            lineHeight: 1.7,
            color: "#1D4ED8",
            fontSize: 15.5,
            marginBottom: 22,
          }}
        >
          <li style={{ marginBottom: 10 }}>
            <span style={{ fontWeight: 600, color: "#1E40AF" }}>
              Enterprise-grade license verification.
            </span>{" "}
            Centralized console for issuing, revoking, and tracking license usage
            across organizations.
          </li>
          <li style={{ marginBottom: 10 }}>
            <span style={{ fontWeight: 600, color: "#1E40AF" }}>
              Identity-aware and device-bound.
            </span>{" "}
            Support for API-based activation, device binding, and audit-ready logs.
          </li>
          <li style={{ marginBottom: 10 }}>
            <span style={{ fontWeight: 600, color: "#1E40AF" }}>
              Built for auditors and software vendors.
            </span>{" "}
            From small firms to large enterprises, available as SaaS or
            on-prem deployment.
          </li>
        </ul>

        {/* Highlight / Stats Row */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 16,
            marginTop: 4,
          }}
        >
          <div
            style={{
              flex: "1 1 140px",
              padding: "12px 14px",
              borderRadius: 14,
              background: "#FFFFFF",
              boxShadow: "0 10px 25px rgba(15,23,42,0.06)",
            }}
          >
            <div
              style={{
                fontSize: 22,
                fontWeight: 800,
                color: "#1D4ED8",
                marginBottom: 4,
              }}
            >
              24/7
            </div>
            <div style={{ fontSize: 13, color: "#6B7280" }}>
              Real-time license verification
            </div>
          </div>

          <div
            style={{
              flex: "1 1 140px",
              padding: "12px 14px",
              borderRadius: 14,
              background: "#FFFFFF",
              boxShadow: "0 10px 25px rgba(15,23,42,0.06)",
            }}
          >
            <div
              style={{
                fontSize: 22,
                fontWeight: 800,
                color: "#1D4ED8",
                marginBottom: 4,
              }}
            >
              ↓ Audit Time
            </div>
            <div style={{ fontSize: 13, color: "#6B7280" }}>
              Cut manual checking with automated logs
            </div>
          </div>

          <div
            style={{
              flex: "1 1 160px",
              padding: "12px 14px",
              borderRadius: 14,
              background: "#FFFFFF",
              boxShadow: "0 10px 25px rgba(15,23,42,0.06)",
            }}
          >
            <div
              style={{
                fontSize: 22,
                fontWeight: 800,
                color: "#1D4ED8",
                marginBottom: 4,
              }}
            >
              Ideal For
            </div>
            <div style={{ fontSize: 13, color: "#6B7280" }}>
              Audit firms, software vendors,  
              enterprise IT & compliance teams.
            </div>
          </div>
        </div>
      </div>

      {/* Right Visual */}
      <div
        className="what-is-image"
        style={{
          flex: 1,
          minHeight: 320,
          minWidth: 0,
          position: "relative",
          borderRadius: 24,
          overflow: "hidden",
          boxShadow: "0 25px 70px rgba(15,23,42,.15)",
          background:
            "linear-gradient(135deg, #0f172a 0%, #1d4ed8 60%, #38bdf8 100%)",
        }}
      >
        {/* Glow */}
        <div
          style={{
            position: "absolute",
            inset: -40,
            background:
              "radial-gradient(circle, rgba(56,189,248,0.25), transparent 60%)",
            zIndex: 1,
          }}
        />

        {/* Image */}
        <img
          src="https://www.theaccountant-online.com/wp-content/uploads/sites/10/2024/11/Wolters-Kluwer-and-IIA-shutterstock_2081143525.jpg"
          alt="Smart Audit console preview"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            position: "relative",
            zIndex: 2,
            filter: "saturate(1.05) contrast(1.05)",
          }}
          loading="lazy"
        />

        {/* Top-left small badge */}
        <div
          style={{
            position: "absolute",
            top: 18,
            left: 18,
            padding: "6px 10px",
            borderRadius: 999,
            background: "rgba(15,23,42,0.75)",
            color: "#E0F2FE",
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: 1,
            textTransform: "uppercase",
            zIndex: 3,
          }}
        >
          Security-first | Audit-ready logs
        </div>

        {/* Frosted overlay card */}
        <div
          style={{
            position: "absolute",
            bottom: 24,
            right: 24,
            left: 24,
            padding: "18px 20px",
            borderRadius: 18,
            backdropFilter: "blur(10px)",
            background: "rgba(15,23,42,0.6)",
            color: "#fff",
            zIndex: 3,
            boxShadow: "0 15px 35px rgba(15,23,42,.35)",
          }}
        >
          <div
            style={{
              fontSize: 14,
              textTransform: "uppercase",
              letterSpacing: 1.2,
              color: "#bae6fd",
            }}
          >
            Live Compliance Dashboard
          </div>
          <div style={{ fontWeight: 700, fontSize: 18, marginTop: 4 }}>
            Real-time license, device, and audit insights
          </div>
          <p
            style={{
              margin: "6px 0 0",
              fontSize: 13.5,
              color: "#e2e8f0",
              lineHeight: 1.5,
            }}
          >
            Monitor license heartbeat, device trust score, and anomaly alerts
            in one unified view – ready for your next audit.
          </p>
        </div>
      </div>
      </div>
    </section>
  );
}


/* ========= Why SmartClick + Video ========= */
function WhySmartClick() {
  return (
    <>
      {/* Why SmartClick */}
      <section
        id="why-smartclick"
        style={{
          background: "#F5F7FA",
          padding: "64px 24px",
          borderTop: "1px solid #E5E7EB",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <div className="content-wrapper">
        {/* Eyebrow */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "4px 10px",
            borderRadius: 999,
            background: "rgba(37, 99, 235, 0.08)",
            color: "#1D4ED8",
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: 0.6,
            textTransform: "uppercase",
            marginBottom: 10,
          }}
        >
          Why teams choose SmartClick
        </div>

        <h2
          style={{
            fontSize: 28,
            fontWeight: 800,
            color: "#0F172A",
            margin: "0 0 8px",
          }}
        >
          Why SmartClick?
        </h2>

        <p
          style={{
            margin: "0 0 28px",
            maxWidth: 760,
            fontSize: 16,
            lineHeight: 1.7,
            color: "#4B5563",
          }}
        >
          SmartClick combines{" "}
          <strong>license automation, audit-ready logging, and local Thai
          support</strong>{" "}
          into a single platform – so your team spends less time chasing license
          issues and more time delivering value to clients.
        </p>

        {/* 3-column value props */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
            gap: 20,
            marginTop: 8,
          }}
        >
          <div
            style={{
              padding: "18px 18px 16px",
              borderRadius: 18,
              background: "#FFFFFF",
              boxShadow: "0 14px 30px rgba(15,23,42,0.06)",
            }}
          >
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: "#1D4ED8",
                marginBottom: 6,
              }}
            >
              End-to-end license automation
            </div>
            <p
              style={{
                margin: 0,
                fontSize: 14,
                lineHeight: 1.6,
                color: "#4B5563",
              }}
            >
              Reduce manual work with API-driven activation, device binding,
              and real-time status tracking across every client.
            </p>
          </div>

          <div
            style={{
              padding: "18px 18px 16px",
              borderRadius: 18,
              background: "#FFFFFF",
              boxShadow: "0 14px 30px rgba(15,23,42,0.06)",
            }}
          >
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: "#1D4ED8",
                marginBottom: 6,
              }}
            >
              Security & compliance by design
            </div>
            <p
              style={{
                margin: 0,
                fontSize: 14,
                lineHeight: 1.6,
                color: "#4B5563",
              }}
            >
              Centralized logs, tamper-resistant history, and audit-ready
              evidence for both internal and external reviewers.
            </p>
          </div>

          <div
            style={{
              padding: "18px 18px 16px",
              borderRadius: 18,
              background: "#FFFFFF",
              boxShadow: "0 14px 30px rgba(15,23,42,0.06)",
            }}
          >
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: "#1D4ED8",
                marginBottom: 6,
              }}
            >
              Local team, global standards
            </div>
            <p
              style={{
                margin: 0,
                fontSize: 14,
                lineHeight: 1.6,
                color: "#4B5563",
              }}
            >
              Thai-based development and support, full Thai/English interface,
              and implementation practices aligned with global best-practice.
            </p>
          </div>
        </div>

        {/* Small hint for target users */}
        <div
          style={{
            marginTop: 18,
            fontSize: 13,
            color: "#6B7280",
          }}
        >
          Ideal for{" "}
          <span style={{ fontWeight: 600, color: "#1F2937" }}>
            audit firms, software vendors, enterprise IT & compliance teams
          </span>{" "}
          that need clear, provable control over software usage.
        </div>
        </div>
      </section>

      {/* Section Video */}
      <section
        style={{
          background: "linear-gradient(180deg,#081a3a 0%,#020617 100%)",
          padding: "36px 24px 44px",
          color: "#E0E7FF",
          textAlign: "center",
        }}
      >
        <div className="content-wrapper">
        <div style={{ marginBottom: 22 }}>
          <div
            style={{
              fontWeight: 700,
              letterSpacing: 1.2,
              fontSize: 13,
              textTransform: "uppercase",
            }}
          >
            See Smart Audit in action
          </div>
          <p
            style={{
              maxWidth: 640,
              margin: "10px auto 0",
              lineHeight: 1.7,
              color: "#CBD5F5",
              fontSize: 14.5,
            }}
          >
            A short product demo showing identity-aware licensing, device
            binding, and how Smart Audit automatically builds the audit trail
            for you.
          </p>
        </div>

        <div
          style={{
            width: "100%",
            maxWidth: 1080,
            margin: "0 auto",
            aspectRatio: "16 / 9",
            maxHeight: "70vh",
            borderRadius: 14,
            overflow: "hidden",
            background: "#020617",
            position: "relative",
            boxShadow: "0 24px 60px rgba(15,23,42,0.7)",
          }}
        >
          {/* Optional overlay label */}
          <div
            style={{
              position: "absolute",
              top: 12,
              left: 14,
              padding: "4px 10px",
              borderRadius: 999,
              background: "rgba(15,23,42,0.8)",
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: 0.8,
              textTransform: "uppercase",
              color: "#BFDBFE",
              zIndex: 2,
            }}
          >
            Product Demo
          </div>

          <VideoWithFallback />
        </div>
        </div>
      </section>
    </>
  );
}


/* ========= CTA Card (ปรับให้เป็นการ์ดขายของแบบหนัก ๆ) ========= */
function CTACard() {
  const goBtnBase = {
    display: "block",
    textDecoration: "none",
    textAlign: "center",
    height: 64,
    lineHeight: "64px",
    fontWeight: 800,
    letterSpacing: 0.5,
    fontSize: 20,
    cursor: "pointer",
    background: "linear-gradient(135deg,#22c55e 0%,#16a34a 40%,#15803d 100%)",
    color: "#fff",
    borderTop: "1px solid rgba(22,163,74,0.45)",
    boxShadow:
      "0 -2px 0 rgba(15,23,42,0.2), 0 18px 40px rgba(22,163,74,0.4)",
    transition:
      "transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease",
  };

  return (
    <section
      id="cta-card"
      style={{
        background: "#F5F7FA",
        padding: "56px 24px 72px",
        textAlign: "center",
      }}
    >
      <div className="content-wrapper">
      <p style={{ margin: 0, color: "#475569", fontSize: 18 }}>
        Are you struggling to manage licenses and ensure compliance?
      </p>
      <h2
        style={{
          margin: "10px 0 8px",
          fontSize: 40,
          fontWeight: 800,
          color: "#0F172A",
          textShadow: "0 3px 10px rgba(15,23,42,0.2)",
        }}
      >
        Choose the best-in-class license solution
      </h2>
      <a
        href="#free-trial"
        style={{
          color: "#2563EB",
          fontSize: 24,
          fontWeight: 700,
          textDecoration: "none",
          padding: "4px 14px",
          borderRadius: 999,
          background: "rgba(191,219,254,0.6)",
        }}
      >
        Get Your Free Quote!
      </a>

      <div
        style={{
          width: "min(760px, 100%)",
          margin: "32px auto 0",
          borderRadius: 18,
          overflow: "hidden",
          boxShadow: "0 24px 60px rgba(15,23,42,0.28)",
          background: "#fff",
          border: "1px solid rgba(15,23,42,0.08)",
        }}
      >
        <div
          style={{
            background:
              "linear-gradient(135deg,#020617 0%,#0f172a 40%,#1d4ed8 100%)",
            color: "#fff",
            height: 72,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 26,
            fontWeight: 800,
            letterSpacing: 0.5,
            textShadow: "0 2px 10px rgba(15,23,42,0.8)",
          }}
        >
          SMART AUDIT PLATFORM
        </div>

        <div
          style={{
            background: "#102B55",
            color: "#fff",
            padding: "24px 28px 26px",
            textAlign: "left",
          }}
        >
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              marginBottom: 10,
              textAlign: "center",
            }}
          >
            License Management &amp; Verification
          </div>
          <p
            style={{
              margin: 0,
              opacity: 0.95,
              lineHeight: 1.6,
              fontSize: 15.5,
            }}
          >
            Prevent unauthorized license usage, ensure compliance, and simplify
            activation across your infrastructure. Smart Audit offers secure,
            real-time license validation with flexible deployment (SaaS or
            On-prem) and transparent audit tracking.
          </p>
        </div>

        <div
          style={{
            background: "#E5E7EB",
            color: "#111827",
            height: 52,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
          }}
        >
          Scalable Licensing
        </div>

        <div
          style={{
            background: "#E5E7EB",
            padding: "18px 28px 24px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              height: 1,
              background: "#CBD5E1",
              width: "70%",
              margin: "0 auto 14px",
            }}
          />
          <div
            style={{
              color: "#111827",
              lineHeight: 1.7,
              fontSize: 15.5,
            }}
          >
            Real-time Verification API, Role-Based Access Control,
            <br />
            Device Binding, Audit Logs &amp; Usage Tracking, Multi-product
            License Support
          </div>
        </div>

        <a
          href="/request"
          target="_blank"
          rel="noopener noreferrer"
          style={goBtnBase}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px) scale(1.01)";
            e.currentTarget.style.boxShadow =
              "0 22px 50px rgba(22,163,74,0.55)";
            e.currentTarget.style.filter = "brightness(1.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0) scale(1)";
            e.currentTarget.style.boxShadow =
              "0 -2px 0 rgba(15,23,42,0.2), 0 18px 40px rgba(22,163,74,0.4)";
            e.currentTarget.style.filter = "brightness(1)";
          }}
        >
          GO !
        </a>
        </div>
      </div>
    </section>
  );
}

/* ========= Free Trial Section ========= */
// Use a stable row style object - do NOT define a Row component inside FreeTrialSection,
// as that would recreate it on every render and cause React to unmount/remount,
// losing uncontrolled input values when the message textarea updates state.
const formRowStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 28,
};

function FreeTrialSection() {
  const navy = "#0E2B55";
  const cyan = "#2BB0F6";
  const blue = "#1663C7";
  const border = "#D1D5DB";
  const inputBg = "#ECEFF1";
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });

  const [messageText, setMessageText] = useState("");
  const maxMessageLength = 200;

  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [industryOpen, setIndustryOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countryOpen, setCountryOpen] = useState(false);
  const industryRef = useRef(null);
  const countryRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (industryRef.current && !industryRef.current.contains(e.target)) setIndustryOpen(false);
      if (countryRef.current && !countryRef.current.contains(e.target)) setCountryOpen(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fieldBase = {
    width: "100%",
    height: 40,
    padding: "0 12px",
    fontSize: 14,
    borderRadius: 6,
    border: `1px solid ${border}`,
    background: inputBg,
  };
  const selectField = {
    ...fieldBase,
    display: "block",
    background: "#F3F4F6",
    color: "#0F172A",
    padding: "0 42px 0 14px",
    height: 44,
    borderRadius: 10,
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%235C677D' viewBox='0 0 20 20'%3E%3Cpath d='M5.23 7.29L10 12.06l4.77-4.77.71.71-5.48 5.48-5.48-5.48.71-.71z'/%3E%3C/svg%3E\")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 14px center",
    backgroundSize: "16px 16px",
    boxShadow: "inset 0 1px 3px rgba(15,23,42,0.08)",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  };
  const textAreaBase = {
    width: "100%",
    minHeight: 110,
    padding: "14px 16px",
    fontSize: 14,
    borderRadius: 10,
    border: `1px solid ${border}`,
    background: "#F3F4F6",
    resize: "vertical",
    boxShadow: "inset 0 1px 3px rgba(15,23,42,0.08)",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  };
  const label = {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 6,
    color: "#111827",
    gap: 4,
  };
  const sectionHeading = {
    fontSize: 13,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 1,
    color: "#4f46e5",
    marginTop: 12,
  };
  const sectionDivider = {
    height: 1,
    background: "#E2E8F0",
    margin: "12px 0 20px",
  };

  const submitBtn = {
    marginTop: 16,
    height: 46,
    padding: "0 22px",
    background:
      "linear-gradient(135deg,#2563eb 0%,#1d4ed8 45%,#4f46e5 100%)",
    color: "#fff",
    fontWeight: 800,
    borderRadius: 999,
    border: "1px solid rgba(37,99,235,0.9)",
    cursor: "pointer",
    boxShadow: "0 10px 28px rgba(37,99,235,0.5)",
    letterSpacing: 0.5,
    transition:
      "transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease",
  };

  // helper POST + timeout
  async function postJSON(url, body, { timeout = 20000 } = {}) {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), timeout);
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        signal: ctrl.signal,
      });
      const ct = res.headers.get("content-type") || "";
      const parse = async () =>
        ct.includes("application/json") ? await res.json() : await res.text();
      if (!res.ok) {
        const err = await parse();
        const msg =
          typeof err === "string"
            ? err
            : Array.isArray(err?.errors)
            ? err.errors
                .map((e) => `${(e.loc || []).join(".")}: ${e.msg}`)
                .join("\n")
            : err?.detail || err?.message || `HTTP ${res.status}`;
        throw new Error(msg);
      }
      return await parse();
    } finally {
      clearTimeout(timer);
    }
  }

  async function onSubmit(e) {
    e.preventDefault();
    if (loading) return;

    const formEl = e.currentTarget;
    const form = new FormData(formEl);
    
    // Sanitize all form inputs
    const formData = {
      firstName: String(form.get("firstName") || ""),
      lastName: String(form.get("lastName") || ""),
      email: String(form.get("email") || ""),
      phone: String(form.get("phone") || ""),
      company: String(form.get("company") || ""),
      industry: String(form.get("industry") || ""),
      country: String(form.get("country") || ""),
      jobTitle: String(form.get("jobTitle") || ""),
      message: String(form.get("message") || ""),
    };
    
    const sanitized = sanitizeFormData(formData);
    
    // Validate required fields
    if (
      !sanitized.firstName ||
      !sanitized.lastName ||
      !sanitized.email ||
      !sanitized.phone ||
      !sanitized.company ||
      !sanitized.industry ||
      !sanitized.country ||
      !sanitized.jobTitle
    ) {
      setMsg({ type: "error", text: getUserFriendlyError("Required fields missing", "validation") });
      return;
    }
    
    // Validate email format
    const emailValidation = sanitizeAndValidateEmail(sanitized.email);
    if (!emailValidation.isValid) {
      setMsg({ type: "error", text: getUserFriendlyError(emailValidation.error, "email") });
      return;
    }

    const payload = {
      firstName: sanitized.firstName,
      lastName: sanitized.lastName,
      email: emailValidation.value,
      phone: sanitized.phone,
      company: sanitized.company,
      industry: sanitized.industry,
      country: sanitized.country,
      jobTitle: sanitized.jobTitle,
      message: sanitized.message,
      utm: {
        path: window.location.pathname + window.location.search,
        ref: document.referrer || "",
      },
    };

    const url = `${API_BASE}/trial-requests`;

    try {
      setLoading(true);
      setMsg({ type: "", text: "" });
      await postJSON(url, payload, { timeout: 20000 });

      setMsg({
        type: "success",
        text: "Request sent! Our team will contact you shortly.",
      });
      formEl.reset();
      setMessageText("");
      setSelectedIndustry("");
      setSelectedCountry("");
      setTimeout(() => setMsg({ type: "", text: "" }), 6000);
    } catch (err) {
      logError(err);
      setMsg({
        type: "error",
        text: getUserFriendlyError(err, "submit"),
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <section
        style={{
          background: navy,
          color: "#fff",
          borderBottom: "1px solid #0b2245",
        }}
        id="free-trial"
      >
        <div className="content-wrapper"
          style={{ maxWidth: 1120, margin: "0 auto", padding: "32px 24px" }}
        >
          <div style={{ fontSize: 22, letterSpacing: 0.2, opacity: 0.95 }}>
            REQUEST YOUR FREE TRIAL
          </div>
          <div
            style={{
              fontSize: 56,
              fontWeight: 700,
              marginTop: 4,
              color: cyan,
            }}
          >
            Smart Audit
          </div>
        </div>
      </section>

      <section style={{ background: "#fff", padding: "48px 24px 80px" }}>
        <div className="content-wrapper"
          style={{
            maxWidth: 1120,
            margin: "0 auto",
          }}
        >
        <div
          className="grid-2"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 60,
            alignItems: "start",
          }}
        >
          {/* ซ้าย: คอนเทนต์ */}
          <div className="free-trial-content" style={{ paddingRight: 20 }}>
            <div
              style={{
                color: blue,
                fontWeight: 800,
                marginBottom: 18,
              }}
            >
              TRY SMART AUDIT FREE FOR A FULL MONTH!
            </div>
            <p style={{ marginTop: 0, color: blue, lineHeight: 1.55 }}>
              <b>Smart Audit by Smart Click</b> is an all-in-one,
              enterprise-ready license management and security platform.
            </p>
            <ul
              style={{
                margin: "16px 0 28px 18px",
                lineHeight: 1.8,
                color: "#111827",
              }}
            >
              <li>Audit &amp; Compliance</li>
              <li>Cyber attacks and Internal Threats</li>
              <li>Third-Party Monitoring and Remote Control</li>
            </ul>
            <div
              style={{
                color: blue,
                fontWeight: 800,
                marginBottom: 12,
              }}
            >
              Why Smart Audit?
            </div>
            <ul
              style={{
                margin: "10px 0 0 18px",
                lineHeight: 1.8,
                color: "#111827",
              }}
            >
              <li>Unified, audit-ready license control</li>
              <li>Real-time license visibility across systems</li>
              <li>Simple, fast onboarding for your team</li>
              <li>Lightweight, secure, and easy to deploy</li>
            </ul>
          </div>

          {/* ขวา: ฟอร์ม */}
          <form
            onSubmit={onSubmit}
            style={{
              width: '100%',
              maxWidth: 520,
              padding: 28,
              background: "#F9FAFB",
              borderRadius: 12,
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            <h3
              style={{
                margin: 0,
                marginBottom: 28,
                fontSize: 22,
                fontWeight: 700,
                color: "#111827",
              }}
            >
              Request your free trial
            </h3>

            {msg.type === "error" && <ErrorMessage message={msg.text} style={{ marginBottom: 16, whiteSpace: "pre-wrap" }} />}
            {msg.type === "success" && <SuccessMessage message={msg.text} style={{ marginBottom: 16, whiteSpace: "pre-wrap" }} />}

            <div style={sectionHeading}>Contact Information</div>
            <div style={sectionDivider} />

            <div className="grid-2" style={formRowStyle}>
              <div style={{ paddingRight: 5 }}>
                <label style={label}>First Name*</label>
                <input
                  placeholder="First Name"
                  required
                  name="firstName"
                  autoComplete="given-name"
                  maxLength={50}
                  style={fieldBase}
                />
              </div>
              <div>
                <label style={label}>Last Name*</label>
                <input
                  placeholder="Last Name"
                  required
                  name="lastName"
                  autoComplete="family-name"
                  maxLength={50}
                  style={fieldBase}
                />
              </div>
            </div>

            <div style={{ height: 24 }} />

            <div className="grid-2" style={formRowStyle}>
              <div style={label}>
                <label style={label}>Email*</label>
                <input
                  type="email"
                  placeholder="Email"
                  required
                  name="email"
                  autoComplete="email"
                  maxLength={254}
                  style={fieldBase}
                />
              </div>
              <div style={label}>
                <label style={label}>Phone*</label>
                <input
                  placeholder="Phone"
                  required
                  name="phone"
                  autoComplete="tel"
                  pattern="^[0-9+()\\-\\.\\s]{6,20}$"
                  title="Please enter a valid phone number (e.g. +66812345678)"
                  maxLength={20}
                  style={fieldBase}
                />
              </div>
            </div>

            <div style={{ height: 24 }} />

            <div style={sectionHeading}>Company Details</div>
            <div style={sectionDivider} />

            <div className="grid-2" style={formRowStyle}>
              <div style={label}>
                <label style={label}>Company*</label>
                <input
                  placeholder="Company"
                  required
                  name="company"
                  autoComplete="organization"
                  maxLength={100}
                  style={fieldBase}
                />
              </div>
              <div style={label}>
                <label style={label}>Industry*</label>
                <div ref={industryRef} style={{ position: "relative" }}>
                  <input type="hidden" name="industry" value={selectedIndustry} />
                  <div
                    onClick={() => { setIndustryOpen((o) => !o); setCountryOpen(false); }}
                    style={{
                      display: "flex", alignItems: "center", justifyContent: "space-between",
                      height: 44, padding: "0 14px", borderRadius: 10, cursor: "pointer",
                      background: "#F3F4F6", fontSize: 14,
                      border: industryOpen ? "1px solid #2563EB" : `1px solid ${border}`,
                      boxShadow: industryOpen ? "0 0 0 2px rgba(37,99,235,0.2)" : "inset 0 1px 3px rgba(15,23,42,0.08)",
                      transition: "border-color 0.2s, box-shadow 0.2s",
                      userSelect: "none",
                    }}
                  >
                    <span style={{ color: selectedIndustry ? "#0F172A" : "#9CA3AF" }}>
                      {selectedIndustry || "-Please Select-"}
                    </span>
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="#5C677D"
                      style={{ flexShrink: 0, transform: industryOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>
                      <path d="M5.23 7.29L10 12.06l4.77-4.77.71.71-5.48 5.48-5.48-5.48.71-.71z"/>
                    </svg>
                  </div>
                  {industryOpen && (
                    <div style={{
                      position: "absolute", top: "calc(100% + 6px)", left: 0, right: 0, zIndex: 200,
                      background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12,
                      boxShadow: "0 10px 30px rgba(0,0,0,0.12), 0 4px 10px rgba(0,0,0,0.06)",
                      overflow: "hidden",
                    }}>
                      {["Technology", "Finance", "Manufacturing", "Healthcare", "Other"].map((opt) => (
                        <div
                          key={opt}
                          onMouseDown={() => { setSelectedIndustry(opt); setIndustryOpen(false); }}
                          style={{
                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            padding: "11px 16px", fontSize: 14, cursor: "pointer",
                            background: selectedIndustry === opt ? "#EFF6FF" : "#fff",
                            color: selectedIndustry === opt ? "#1D4ED8" : "#111827",
                            fontWeight: selectedIndustry === opt ? 600 : 400,
                            transition: "background 0.1s",
                          }}
                          onMouseEnter={(e) => { if (selectedIndustry !== opt) e.currentTarget.style.background = "#F9FAFB"; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = selectedIndustry === opt ? "#EFF6FF" : "#fff"; }}
                        >
                          {opt}
                          {selectedIndustry === opt && (
                            <svg width="15" height="15" viewBox="0 0 20 20" fill="#1D4ED8">
                              <path d="M16.7 5.3l-7.4 7.4-3.7-3.7 1.4-1.4 2.3 2.3 6-6 1.4 1.4z"/>
                            </svg>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div style={{ fontSize: 12, color: "#6B7280", marginTop: 8 }}>
                  Required so we can match you with the right specialist.
                </div>
              </div>
            </div>

            <div style={{ height: 24 }} />

            <div className="grid-2" style={formRowStyle}>
              <div style={label}>
                <label style={label}>Country*</label>
                <div ref={countryRef} style={{ position: "relative" }}>
                  <input type="hidden" name="country" value={selectedCountry} />
                  <div
                    onClick={() => { setCountryOpen((o) => !o); setIndustryOpen(false); }}
                    style={{
                      display: "flex", alignItems: "center", justifyContent: "space-between",
                      height: 44, padding: "0 14px", borderRadius: 10, cursor: "pointer",
                      background: "#F3F4F6", fontSize: 14,
                      border: countryOpen ? "1px solid #2563EB" : `1px solid ${border}`,
                      boxShadow: countryOpen ? "0 0 0 2px rgba(37,99,235,0.2)" : "inset 0 1px 3px rgba(15,23,42,0.08)",
                      transition: "border-color 0.2s, box-shadow 0.2s",
                      userSelect: "none",
                    }}
                  >
                    <span style={{ color: selectedCountry ? "#0F172A" : "#9CA3AF" }}>
                      {selectedCountry || "-Please Select-"}
                    </span>
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="#5C677D"
                      style={{ flexShrink: 0, transform: countryOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>
                      <path d="M5.23 7.29L10 12.06l4.77-4.77.71.71-5.48 5.48-5.48-5.48.71-.71z"/>
                    </svg>
                  </div>
                  {countryOpen && (
                    <div style={{
                      position: "absolute", top: "calc(100% + 6px)", left: 0, right: 0, zIndex: 200,
                      background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12,
                      boxShadow: "0 10px 30px rgba(0,0,0,0.12), 0 4px 10px rgba(0,0,0,0.06)",
                      overflow: "hidden",
                    }}>
                      {["Thailand", "Singapore", "Malaysia", "Vietnam", "Other"].map((opt) => (
                        <div
                          key={opt}
                          onMouseDown={() => { setSelectedCountry(opt); setCountryOpen(false); }}
                          style={{
                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            padding: "11px 16px", fontSize: 14, cursor: "pointer",
                            background: selectedCountry === opt ? "#EFF6FF" : "#fff",
                            color: selectedCountry === opt ? "#1D4ED8" : "#111827",
                            fontWeight: selectedCountry === opt ? 600 : 400,
                            transition: "background 0.1s",
                          }}
                          onMouseEnter={(e) => { if (selectedCountry !== opt) e.currentTarget.style.background = "#F9FAFB"; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = selectedCountry === opt ? "#EFF6FF" : "#fff"; }}
                        >
                          {opt}
                          {selectedCountry === opt && (
                            <svg width="15" height="15" viewBox="0 0 20 20" fill="#1D4ED8">
                              <path d="M16.7 5.3l-7.4 7.4-3.7-3.7 1.4-1.4 2.3 2.3 6-6 1.4 1.4z"/>
                            </svg>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div style={label}>
                <label style={label}>Job title*</label>
                <input
                  placeholder="Job title"
                  required
                  name="jobTitle"
                  autoComplete="organization-title"
                  maxLength={80}
                  style={fieldBase}
                />
              </div>
            </div>

            <div style={{ height: 24 }} />

            <div style={label}>
              <label style={label}>Message (optional)</label>
              <textarea
                name="message"
                placeholder="Tell us about your use case..."
                style={textAreaBase}
                rows={4}
                maxLength={maxMessageLength}
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                onFocus={(e) => {
                  e.target.style.borderColor = "#2563EB";
                  e.target.style.boxShadow =
                    "0 0 0 2px rgba(37,99,235,0.25)";
                  e.target.style.background = "#fff";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = border;
                  e.target.style.boxShadow =
                    "inset 0 1px 3px rgba(15,23,42,0.08)";
                  e.target.style.background = "#F3F4F6";
                }}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: 12,
                  color: "#6B7280",
                  marginTop: 6,
                  gap: 8,
                }}
              >
                <span>
                  Optional: share requirements or integrations you have in
                  mind.
                </span>
                <span>
                  {messageText.length}/{maxMessageLength}
                </span>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              aria-label={loading ? "Submitting form, please wait" : "Submit form"}
              style={{
                ...submitBtn,
                background: loading
                  ? "linear-gradient(135deg,#9ca3af 0%,#6b7280 100%)"
                  : submitBtn.background,
                boxShadow: loading ? "none" : submitBtn.boxShadow,
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.25s ease, opacity 0.2s ease",
                opacity: loading ? 0.7 : 1,
              }}
              onMouseEnter={(e) => {
                if (loading) return;
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 16px 40px rgba(37,99,235,0.65)";
                e.currentTarget.style.filter = "brightness(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 10px 28px rgba(37,99,235,0.5)";
                e.currentTarget.style.filter = "brightness(1)";
              }}
            >
              {loading ? "Submitting..." : "SUBMIT"}
            </button>
          </form>
        </div>
        </div>
      </section>
    </>
  );
}

// ใช้ shared Footer component แทน - ลบ function เดิมออกแล้ว

function VideoWithFallback() {
  const [failed, setFailed] = React.useState(false);
  if (failed) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          minHeight: 280,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#020617",
          color: "#93C5FD",
          gap: 12,
          fontSize: 14,
        }}
      >
        <div style={{ fontSize: 40 }}>🎬</div>
        <div>Video unavailable.</div>
        <a
          href="/videos/SmartAudit_Identity_Access_Management.mp4"
          style={{ color: "#60A5FA", textDecoration: "underline" }}
        >
          Download the clip
        </a>
      </div>
    );
  }
  return (
    <video
      src="/videos/SmartAudit_Identity_Access_Management.mp4"
      poster="/videos/video-poster.jpg.jpg"
      controls
      playsInline
      preload="metadata"
      onError={() => setFailed(true)}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        display: "block",
        background: "#020617",
      }}
    >
      Sorry, your browser doesn't support embedded videos.{" "}
      <a
        href="/videos/SmartAudit_Identity_Access_Management.mp4"
        style={{ color: "#93C5FD" }}
      >
        Download the clip
      </a>
      .
    </video>
  );
}
